import GrEmployeeComponent from './gr-employee';

export default GrEmployeeComponent;